const routes = [
  {
    path: '/video-comments',
    name: 'video-comments',
    meta: {
      authRequired: true,
      permission: 'video.edit'
    },
    component: () => import('./Index.vue')
  }
]

export default routes
